/**
 * Created by koqiui on 2017-04-09.
 */
import { Utils } from '../../app.base'
import { Vue } from '../../app.vues'
//
import SwbCronEditor from './CronEditor';

Vue.regist(SwbCronEditor);

export function openCronEditorDlg(params, callback) {
    let cronJson = params.cronJson || {};   // 回显的周期
    let timeLimit = params.timeLimit;
    let fixedYear = params.fixedYear != false;
    //固定类型
    let fixedYearType = params.fixedYearType != false;
    let fixedMonthType = params.fixedMonthType == true;
    let fixedDayType = params.fixedDayType == true;
    let fixedHourType = params.fixedHourType == true;
    let fixedMinuteType = params.fixedMinuteType != false;
    let fixedSecondType = params.fixedSecondType == true;
    //
    Vue.$showDialog({
        title: '周期设置',
        width: 600,
        height: 500,
        showCloseBtn: true,
        template: '<swb-cron-editor \
        :jsonValue="cronJson" \
        :fixedYearType="fixedYearType" \
        :fixedMonthType="fixedMonthType" \
        :fixedDayType="fixedDayType" \
        :fixedHourType="fixedHourType" \
        :fixedMinuteType="fixedMinuteType" \
        :fixedSecondType="fixedSecondType" \
        :fixedYear="fixedYear" :timeLimit="timeLimit" ref="swb_cron_editor">\
        </swb-cron-editor>',
        data: {
            cronJson: cronJson,
            timeLimit: timeLimit,
            fixedYear: fixedYear,
            //
            fixedYearType: fixedYearType,
            fixedMonthType: fixedMonthType,
            fixedDayType: fixedDayType,
            fixedHourType: fixedHourType,
            fixedMinuteType: fixedMinuteType,
            fixedSecondType: fixedSecondType
        },
        okClicked: function () {
            let jsonResult = this.$refs['swb_cron_editor'].getResult() || {};
            if(jsonResult.type == 'info') {
                callback(jsonResult);
            } else {
                Toast.show(jsonResult.message);
                return false;
            }
        },
        methods: {}
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/cron/selectDlg.js
// module id = 97
// module chunks = 0